import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Participant } from './entities/Participant';
import { Patient } from './entities/Patient';
import { UserType } from './entities/UserType';
import { CONSTANTS } from 'src/app/CONSTS';
import { CometChat } from '@cometchat/chat-sdk-ionic';
@Injectable()
export class CoreService {
  constructor(private http: HttpClient) { }
  
  getParticipants(uid: string): Observable<Participant[]> {
		return this.postData("Patient/GetParticipants", {
			uid: uid
		});
	}
	getUsersByWorker(workerId, businessId): Observable<Patient[]> {
		const date = new Date();
		return this.postData("Patient/GetAssignedPatients", {
			WorkerId: workerId,
			BusinessId: businessId,
			Date: date
		});
	}

	getAssignedWorker(patientId, businessId): Observable<number> {
		return this.postData("Patient/GetAssignedWorker", {
			PatientId: patientId,
			BusinessId: businessId
		});
	}
	// TODO move bellow two functions to helpers
	getSVGAvatar(generator: string, data: string) {
		const svg1 = document.createElementNS("http://www.w3.org/2000/svg", "svg");
		svg1.setAttribute("width", "200");
		svg1.setAttribute("height", "200");

		const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
		rect.setAttribute('x', '0');
		rect.setAttribute('y', '0');
		rect.setAttribute('width', '200');
		rect.setAttribute('height', '200');
		rect.setAttribute('fill', this.stringToColour(generator));
		const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
		text.setAttribute('x', '50%');
		text.setAttribute('y', '54%');
		text.setAttribute('dominant-baseline', 'middle');
		text.setAttribute('text-anchor', 'middle');
		text.setAttribute('fill', 'white');
		text.setAttribute('font-size', '120');
		text.setAttribute('font-family', "'Inter', sans-serif");
		text.setAttribute('font-wight', "600");
		text.textContent = data;
		svg1.appendChild(rect);
		svg1.appendChild(text);
		let svgString = new XMLSerializer().serializeToString(svg1);


		let decoded = unescape(encodeURIComponent(svgString));
		let base64 = btoa(decoded);

		let imgSource = `data:image/svg+xml;base64,${base64}`;
		return imgSource;
	}
	stringToColour(str) {
		let hash = 0;
		for (let i = 0; i < str.length; i++) {
			// tslint:disable-next-line: no-bitwise
			hash = str.charCodeAt(i) + ((hash << 5) - hash);
		}
		let colour = '#';
		for (let i = 0; i < 3; i++) {
			// tslint:disable-next-line: no-bitwise
			const value = (hash >> (i * 8)) & 0xFF;
			colour += ('00' + value.toString(16)).substr(-2);
		}
		return colour;
	}




  /**
   * Create user
   * @param uid
   */
  createUsers(users: Participant[]): Observable<string> {
    return new Observable<string>(observer => {
      const l = users.length;
      let i = 0;
      users.forEach(u => {
        const username = (u.type === UserType.Patient ? CONSTANTS.PATIENT_PREFIX : 
          (u.type === UserType.Contact ? CONSTANTS.CONTACT_PREFIX: '')
          ) + u.uid;
        this.createUserApi(username, u.name).subscribe(
          () => {
            i++;
            if (i === l) {
              observer.next('completed');
            }
          }, error => {
            console.log('error', error);
            i++;
            if (i === l) {
              observer.next('completed');
            }
          }
        );
      });
    });
  }

  /**
   * Find user
   * @param uid
   */
  findUser(uid): Observable<number> {
    return Observable.create((observer) => {
      const data = JSON.stringify({});

      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (this.readyState === this.DONE) {
          observer.next(this.status);
        }
      };
      xhr.open('GET', 'https://'+ environment.APP_ID + '.api-' + environment.region + '.cometchat.io/v3.0/users/' + uid);
      xhr.setRequestHeader('content-type', 'application/json');
      xhr.setRequestHeader('accept', 'application/json');
      xhr.setRequestHeader('appId', environment.APP_ID);
      xhr.setRequestHeader('apiKey', environment.REST_KEY);
      xhr.send(data);
    });
  }

  addMemberToGroup(uid, list: any[]): Observable<number> {
    return Observable.create((observer) => {
      uid = uid.toLowerCase();
      const membersList = [];
      list.splice(0, 1);
      list.forEach(u => {
        membersList.push(new CometChat.GroupMember(u.name, CometChat.GROUP_MEMBER_SCOPE.PARTICIPANT));
      });

      CometChat.addMembersToGroup(uid, membersList, []).then(
        response => {
          return observer.next('true');
        },
        error => {
          console.log('Something went wrong', error);
          return observer.next('true');
        }
      );
    });
  }

  deleteUser(id) {
    const data = JSON.stringify({
      permanent: true
    });

    const xhr = new XMLHttpRequest();

    xhr.addEventListener('readystatechange', function () {
      if (this.readyState === this.DONE) {
        console.log(this.responseText);
      }
    });
    xhr.open('DELETE', 'https://'+ environment.APP_ID + '.api-' + environment.region + '.cometchat.io/v3.0/users/' + id);
    xhr.setRequestHeader('content-type', 'application/json');
    xhr.setRequestHeader('accept', 'application/json');
    xhr.setRequestHeader('appId', environment.APP_ID);
    xhr.setRequestHeader('apiKey', environment.REST_KEY);
    xhr.send(data);
  }
  
  createUserApi(uid, name): Observable<any> {
    return new Observable((observer) => {  // Use new Observable instead of Observable.create
      const data = JSON.stringify({
        uid: uid,
        name: name
      });
  
      const xhr = new XMLHttpRequest();
  
      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
          console.log(this.responseText);
          observer.next("true");
        }
      });
  
      xhr.open("POST", "https://" + environment.APP_ID + ".api-" + environment.region + ".cometchat.io/v3.0/users");
      xhr.setRequestHeader("content-type", "application/json");
      xhr.setRequestHeader("accept", "application/json");
      xhr.setRequestHeader('appId', environment.APP_ID);
      xhr.setRequestHeader('apiKey', environment.REST_KEY);
      xhr.send(data);
    });
  }
  /*autologinWithCreateUser(uid, type) {
    this.findUser2(uid).subscribe(r => {
      if (r == 404) //user not found
        this.createWithLoginUser(uid, type);
      if (r == 200) //user found
        this.login(uid, type);
    }, err => {
      console.log(err);
    });
  }*/



  /**
   * Create group
   * @param uid
   */
  createGroup(uid): Observable<any> {
    return Observable.create((observer) => {
      const GUID = uid;
      const groupName = uid;
      const groupType = CometChat.GROUP_TYPE.PRIVATE;


      const group = new CometChat.Group(GUID, groupName, groupType);

      CometChat.createGroup(group).then(
        group => {
          observer.next(group);
        },
        error => {
          console.log('Group creation failed with exception:', error);
          observer.next('error');
        }
      );
    });
  }

	postData(path: string, paramData: any): Observable<any> {
		var headers = new HttpHeaders();
		headers.append('Authorization', 'bearer ');
		//headers.append('Content-Type', 'application/x-www-form-urlencoded');                  
		var params = new HttpParams();
		if (paramData) {
			for (var p in paramData) {
				params = params.set(p, paramData[p]);
			}
		}
		return this.http.post(environment.serviceUrl + path, paramData, { headers: headers });
	}
  replaceCometChatUid(str) {
    if(str){
      str = str.replace('.', '');
      str = str.replace(' ', '');
      str = str.replace('@', '');
      str = str.replace('_', '');
    }
    return str;
  }
}
